import React, { useEffect, useState } from "react"
import { Collapse, Dropdown, DropdownButton } from "react-bootstrap"
import { useCookies } from "react-cookie"
import { useSelector } from "react-redux"
import { Link, useLocation, useNavigate } from "react-router-dom"
import LogoFull from "../../assets/images/logo.svg"
import Header from "./Header"
import ChangePassword from "../ChangePassword"
import { modulePermission } from "../../lib/GlobalVariables"

const Sidebar = () => {
  const [show, setShow] = useState(false)
  const [modalshow, modalsetShow] = useState(false)

  const handleShow = () => {
    modalsetShow(true)
  }
  const showDropdown = (e) => {
    setShow(!show)
  }
  const hideDropdown = (e) => {
    setShow(false)
  }
  const location = useLocation()
  const getActiveClass = (paths) => {
    return paths.includes(location.pathname) ? "active" : ""
  }
  const [, , removeCookie] = useCookies(["authToken"])
  const navigate = useNavigate()
  const { userDetails } = useSelector((state) => state.basicInformation)
  const modulePermissionList = useSelector(
    (state) => state.modulePermissions.modulePermissionList,
  )
console.log("MODULE PERMISSION LIST:", modulePermissionList)
console.log(
  "FLEET MANAGEMENT:",
  modulePermissionList["fleet management"],
)
console.log(
  "HAS FLEET MANAGEMENT:",
  Object.keys(modulePermissionList).includes(
    modulePermission.fleetManagement,
  ),
)
  const settingsPaths = [
    "/vehicle-management",
    "/content-management",
    "/admin-role",
    "/manage-permissions",
    "/connectors-management",
    "/amenities-management",
    "/brands-management",
    "/fee-management",
    "/fleet-vendor-wallets",
  ]

  const fleetManagementPaths = [
    "/fleet-client-management",
    "/fleet-vendor-management",
    "/fleet-vehicle-management",
  ]

  const canViewFleetVendorWallets =
    userDetails?.role === "Super Admin" &&
    modulePermissionList[modulePermission.fleetManagement]?.some(
      (permission) => permission.permission === "view",
    )

  const [collapseState, setCollapseState] = useState({
    settings: false,
    userSettings: false,
    fleetManagement: false,
  })

  useEffect(() => {
    if (settingsPaths.includes(location.pathname)) {
      setCollapseState((prevState) => ({
        ...prevState,
        settings: true,
        fleetManagement: false,
      }))
    } else if (fleetManagementPaths.includes(location.pathname)) {
      setCollapseState((prevState) => ({
        ...prevState,
        settings: false,
        fleetManagement: true,
      }))
    } else {
      setCollapseState((prevState) => ({
        ...prevState,
        settings: false,
        fleetManagement: false,
      }))
    }
  }, [location.pathname])

  const toggleCollapse = (key) => {
    setCollapseState((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }))
  }

  const logout = () => {
    removeCookie("authToken")
    navigate("/login")
  }

  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const toggleSidebar = () => {
    if (window.innerWidth <= 992) {
      setIsSidebarOpen(!isSidebarOpen)
    }
  }

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992 && isSidebarOpen) {
        setIsSidebarOpen(false)
      }
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [isSidebarOpen])

  return (
    <>
      <Header toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
      <div>
        <div
          className={`d-lg-none ${isSidebarOpen ? "sidebar_overlay_bg" : ""}`}
          onClick={toggleSidebar}
        ></div>
        <aside className={`app_sidebar ${isSidebarOpen ? "sidebar_open" : ""}`}>
          <div className="header side_header text-center">
            <Link
              to="/dashboard"
              className="position-relative border-bottom border-opacity-25 border-secondary logo_full d-flex justify-content-center"
            >
              <img src={LogoFull} alt="Megacharge" />
              <sub className="role_admin">
                {userDetails?.role + " "}
                <small className="text-lowercase">
                  v {process.env.REACT_APP_VERSION}
                </small>
              </sub>
            </Link>
          </div>
          <div className="main_sidemenu">
            <ul className="menuitems_wrapper list-unstyled">
              <li
                className={`menuitem_list ${getActiveClass("/dashboard")}`}
                onClick={toggleSidebar}
              >
                <Link to="/dashboard" className="menuitem_link">
                  <i className="icon_main house_door"></i>Dashboard
                </Link>
              </li>

              {Object.keys(modulePermissionList).includes(
                modulePermission.booking,
              ) && (
                <li
                  className={`menuitem_list ${getActiveClass("/booking")}`}
                  onClick={toggleSidebar}
                >
                  <Link to="/booking" className="menuitem_link">
                    <i className="icon_main receipt"></i>Booking Management
                  </Link>
                </li>
              )}
              {Object.keys(modulePermissionList).includes(
                modulePermission.user,
              ) &&
                userDetails?.dataScope !== "OWN" && (
                  <li
                    className={`menuitem_list ${getActiveClass("/users")}`}
                    onClick={toggleSidebar}
                  >
                    <Link to="/users" className="menuitem_link">
                      <i className="icon_main people_users"></i>Users
                    </Link>
                  </li>
                )}
              {Object.keys(modulePermissionList).includes(
                modulePermission.station,
              ) && (
                <li
                  className={`menuitem_list ${
                    getActiveClass("/charging-stations") ||
                    getActiveClass("/charging-station-details")
                  }`}
                  onClick={toggleSidebar}
                >
                  <Link to="/charging-stations" className="menuitem_link">
                    <i className="icon_main chargin_stations"></i>Charging
                    Stations
                  </Link>
                </li>
              )}
              {Object.keys(modulePermissionList).includes(
                modulePermission.review,
              ) && (
                <li
                  className={`menuitem_list ${getActiveClass(
                    "/stations-reviews",
                  )}`}
                  onClick={toggleSidebar}
                >
                  <Link to="/stations-review" className="menuitem_link">
                    <i className="icon_main star_review"></i>Stations Review
                  </Link>
                </li>
              )}
              {Object.keys(modulePermissionList).includes(
                modulePermission.charger,
              ) &&
                userDetails?.dataScope !== "OWN" && (
                  <li
                    className={`menuitem_list ${getActiveClass(
                      "/charger-management",
                    )}`}
                    onClick={toggleSidebar}
                  >
                    <Link to="/charger-management" className="menuitem_link">
                      <i className="icon_main connector_icon"></i>Chargers
                    </Link>
                  </li>
                )}


              {modulePermissionList[modulePermission.productionLogs]?.some(
                (permission) => permission.permission === "view",
              ) && (
                <li
                  className={`menuitem_list ${getActiveClass(
                    "/production-logs",
                  )}`}
                  onClick={toggleSidebar}
                >
                  <Link to="/production-logs" className="menuitem_link">
                    <i className="icon_main receipt"></i>Production Logs
                  </Link>
                </li>
              )}
              {Object.keys(modulePermissionList).includes(
                modulePermission.fleetManagement,
              ) && (
                <li
                  className={`menuitem_list ${getActiveClass(fleetManagementPaths)}`}
                >
                  <button
                    onClick={() => toggleCollapse("fleetManagement")}
                    aria-controls="fleet-management-collapse"
                    aria-expanded={collapseState.fleetManagement}
                    className="menuitem_link m_subitem_link"
                  >
                    <div className="btn_subitems">
                      <i className="icon_main ev_vehicles"></i>
                      Fleet Management
                    </div>

                    <i className="icon_main arrowright_sibebar"></i>
                  </button>

                  <Collapse in={collapseState.fleetManagement}>
                    <ul
                      id="fleet-management-collapse"
                      className="submenuitems_wrapper list-unstyled"
                    >
                      <li
                        className={`submenuitem_list ${getActiveClass(
                          "/fleet-client-management",
                        )}`}
                        onClick={toggleSidebar}
                      >
                        <Link
                          to="/fleet-client-management"
                          className="submenuitem_link"
                        >
                          Fleet Client
                        </Link>
                      </li>

                      <li
                        className={`submenuitem_list ${getActiveClass(
                          "/fleet-vendor-management",
                        )}`}
                        onClick={toggleSidebar}
                      >
                        <Link
                          to="/fleet-vendor-management"
                          className="submenuitem_link"
                        >
                          Fleet Vendor
                        </Link>
                      </li>

                      <li
                        className={`submenuitem_list ${getActiveClass(
                          "/fleet-vehicle-management",
                        )}`}
                        onClick={toggleSidebar}
                      >
                        <Link
                          to="/fleet-vehicle-management"
                          className="submenuitem_link"
                        >
                          Fleet Vehicle
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
              )}

              {Object.keys(modulePermissionList).includes(
                modulePermission.setting,
              ) && (
                <li
                  className={`menuitem_list ${getActiveClass(settingsPaths)}`}
                >
                  <button
                    onClick={() => toggleCollapse("settings")}
                    aria-controls="example-collapse-text"
                    aria-expanded={collapseState.settings}
                    className="menuitem_link m_subitem_link"
                  >
                    <div className="btn_subitems">
                      <i className="icon_main gear_setting"></i>Settings
                    </div>
                    <i className="icon_main arrowright_sibebar"></i>
                  </button>
                  <Collapse in={collapseState.settings}>
                    <ul
                      id="example-collapse-text"
                      className="submenuitems_wrapper list-unstyled"
                    >
                      {userDetails?.dataScope !== "OWN" && (
                        <li
                          className={`submenuitem_list ${getActiveClass(
                            "/brands-management",
                          )}`}
                          onClick={toggleSidebar}
                        >
                          <Link
                            to="/brands-management"
                            className="submenuitem_link"
                          >
                            Brands
                          </Link>
                        </li>
                      )}
                      {userDetails?.dataScope !== "OWN" && (
                        <li
                          className={`submenuitem_list ${getActiveClass(
                            "/vehicle-management",
                          )}`}
                          onClick={toggleSidebar}
                        >
                          <Link
                            to="/vehicle-management"
                            className="submenuitem_link"
                          >
                            Vehicles
                          </Link>
                        </li>
                      )}
                      {userDetails?.dataScope !== "OWN" && (
                        <li
                          className={`submenuitem_list ${getActiveClass(
                            "/connectors-management",
                          )}`}
                          onClick={toggleSidebar}
                        >
                          <Link
                            to="/connectors-management"
                            className="submenuitem_link"
                          >
                            Connectors
                          </Link>
                        </li>
                      )}
                      {userDetails?.dataScope !== "OWN" && (
                        <li
                          className={`submenuitem_list ${getActiveClass(
                            "/amenities-management",
                          )}`}
                          onClick={toggleSidebar}
                        >
                          <Link
                            to="/amenities-management"
                            className="submenuitem_link"
                          >
                            Amenities
                          </Link>
                        </li>
                      )}
                      {userDetails?.dataScope !== "OWN" && (
                        <li
                          className={`submenuitem_list ${getActiveClass(
                            "/content-management",
                          )}`}
                          onClick={toggleSidebar}
                        >
                          <Link
                            to="/content-management"
                            className="submenuitem_link"
                          >
                            Contents
                          </Link>
                        </li>
                      )}

                      <li
                        className={`submenuitem_list ${getActiveClass(
                          "/fee-management",
                        )}`}
                        onClick={toggleSidebar}
                      >
                        <Link to="/fee-management" className="submenuitem_link">
                          Fee
                        </Link>
                      </li>

                      {userDetails?.role &&
                      userDetails.role === "Super Admin" ? (
                        <>
                          {canViewFleetVendorWallets && (
                            <li
                              className={`submenuitem_list ${getActiveClass(
                                "/fleet-vendor-wallets",
                              )}`}
                              onClick={toggleSidebar}
                            >
                              <Link
                                to="/fleet-vendor-wallets"
                                className="submenuitem_link"
                              >
                                Fleet Vendor Wallets
                              </Link>
                            </li>
                          )}
                          <li
                            className={`submenuitem_list ${getActiveClass(
                              "/admin-role",
                            )}`}
                            onClick={toggleSidebar}
                          >
                            <Link to="/admin-role" className="submenuitem_link">
                              Manage Role
                            </Link>
                          </li>
                          <li
                            className={`submenuitem_list ${getActiveClass(
                              "/manage-permissions",
                            )}`}
                            onClick={toggleSidebar}
                          >
                            <Link
                              to="/manage-permissions"
                              className="submenuitem_link"
                            >
                              Manage Users
                            </Link>
                          </li>{" "}
                        </>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Collapse>
                </li>
              )}
            </ul>
            <DropdownButton
              id={`profile_dropdown`}
              drop="up-centered"
              variant="link"
              className="profile_drop_wrapper"
              title={
                <>
                  <i
                    className="avtar_nm"
                    data-name={
                      userDetails?.firstname.charAt(0) +
                      userDetails?.lastname.charAt(0)
                    }
                  ></i>{" "}
                  <div
                    className="user_nmmail"
                    title={
                      userDetails?.firstname +
                      " " +
                      userDetails?.lastname +
                      " (" +
                      userDetails?.email +
                      ")"
                    }
                  >
                    <p className="mb-0">
                      {userDetails?.firstname + " " + userDetails?.lastname}
                    </p>
                    <span className="d-block">{userDetails?.email}</span>
                  </div>
                </>
              }
              show={show}
              onMouseEnter={showDropdown}
              onMouseLeave={hideDropdown}
            >
              <Dropdown.Item eventKey="1" onClick={handleShow}>
                Change Password
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item eventKey="2" onClick={() => logout()}>
                Logout
              </Dropdown.Item>
            </DropdownButton>
          </div>
        </aside>
      </div>
      <ChangePassword show={modalshow} modalsetShow={modalsetShow} />
    </>
  )
}

export default Sidebar
